export default __webpack_public_path__ + "static/media/page-title.ed9b65de.jpg";